import { faComment,faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';
import Tweet from './tweet';
import Retweet from './retweet';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';
import {useState,useRef, useEffect}  from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import nolan2 from './nolan2.jpg';
import nolan1 from './nolan1.jpg';
import { useNavigate } from 'react-router-dom';
import {faTrashCan} from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import {like,comment,retweet,deletepost,addPost,retweetPost,setProfileImg} from'./redux/chatSlice';
import {Link} from 'react-router-dom';
function Chat({currentUser,closePopup}){
const [showTrash,setShowTrash]=useState(null);
const [ShowEdit,setShowEdit]=useState(null);
const [ShowUpload,setShowUpload]=useState(false);
const [ShowTweet,setShowTweet]=useState(false);
const [ShowReTweet,setShowReTweet]=useState(false);
const [box,setBox]=useState(null);
const [hover,setHover]=useState(null);
const dispatch= useDispatch();
const Post = useSelector((state)=>state.post.post);
const timeRef=useRef(null);
     const navigate=useNavigate();

//set long press
const handleMouseDown=(id)=>{
timeRef.current=setTimeout(()=>{
setShowTrash(id);
},600);
};
//cancel long press
const handleMouseLeave=()=>{
clearTimeout(timeRef.current);
}
const handleMouseUp=()=>{
clearTimeout(timeRef.current);
}
//to delete
const onDelete=(id)=>{
dispatch(deletepost(id));
setShowTrash(null);
};

//get tweet
/*useEffect(() =>{
   const fetchTweets= async ()=>{
try{
 const data=await axios.get('http://posttweet');
console.log(data);
   console.log('tweet data posted ');
    }catch(err){
      console.log(' internal err ');
    };
   };
    fetchTweets();
   },[]);
};

//access control
useEffect(()=>{
   const currentUser =localStorage.getItem('currentUser');
   if(!currentUser){
      navigate('/login');
   }
},[navigate]);
*/
if (!Post) return null;
return(
   <div className="parent"  style={{display:'flex',flexDirection:'row'}}>
    <div style={{display:'flex',gap:'5px',flexDirection:'column',padding:'30px',textAlign:'center'}}>
       <>
        <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSO8KqQGwc4YoGzHnx82fyY-X5VHecRsAFhjQ&s'style={{width:'50px'}}/>
        <p></p>
        <Link to='/user_profile'>
        <img  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAdVBMVEX///8AAABgYGD8/Pzk5OQkJCQEBAT5+fkICAj29vYnJye9vb3s7Ow1NTXp6enPz8+FhYXV1dVbW1stLS2Tk5M7OzvKysqBgYHDw8OioqJNTU13d3eLi4uWlpYTExNqamqwsLCrq6vd3d1FRUVUVFQdHR1vb288+g1dAAAEv0lEQVR4nO3cCXeiPBQG4IQgiLjhUpdqxW7//yd+WdDRjoOEipfL9z5z2jlTx9O8vSGEECoEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMD/jlL2Q7l/FH+bLxl0zXoYJVwMlYTp4jWYzWbB6yIdJ+YVEZ9eZczUT+eI091cXprv1ra03PMJG1GEexsviiKbzn2Wo03YhYzmANy8XZXvlFDK3kaw7qW67bp/ivRHviu9tR17mKY0HTBOdhc1+0tfyoU5SvUfjkzC4dIcfv+uoX5pOxRsaxiLbOkKVRrx411wraEIRzpBSQWlG1+XY+qm+nOjRzi4E+9UxtGQ3WhjDkGVBGWDzFVHPcSKY8RdhXSniAvBbf6mG/tSNP5+QDPYZvbcyYgSyae8O8ycSxjJIOY1f9Nt3VTto4Wcus1+dAlHngmX3E6JR8+A7IoYb70TBqyOQxF6B5SS18xmUe1E8Yf+3xvqRnuZ+SbUDtSN9hH6jqTGckjdbA8T/xJG8i2jbraHtE5CuaZutoe9ZzznSN1sD9NaCRfUzfbwWivhlLrZHr47n7BeDXfUzfZQ+fL+CqdJzVHWmNPInLrZHta1avhC3WwP2VeNgIN36mZ7MIv53j4S6mb78B9MI7mibrSXvEYNOU1LdTf1D/jGqpMqsfJOuGO1rK/circXTleHdhdJYFfrK532I3MT9ZvXfVKlRFZ1UV+6u8S8Smh3YKxkv3IN+3LH67aFvd+ZfHnMTUcxv30nqvJijemja263D52ja33ZXozih5BTN7Uepab3qlgcqJwufS/pjvcqyzO61zitXlxLRLyQ9zPuuW1SuKDurZya7BuWY8yF7KOIEv2MZm05XfbepOJk93Z7eqO/8rVPmBdQz1D1FDVcXZfuHHY6ZrcX6m+u/eP9Nvox5vS3+2EXtghbJkSSLS5v7X/uM7uXXXHbgXHHcJLmxzydcLoVWlcn+uYt6vy5mxHPw0o3hpdSXUio/GKwi1zvHMCp854TVm2zKorOKKOIk3FY3ThhdOo3ZXjZrILtaD7oVTOYj7aH6WYiWlxEVZwK9Md77r/z8jyZy8PicGzdypQqIqpJMKidz5gfsrY+B2XHivTTtNL/Dn7BvXG2NkNV+y6rdHsmM+mecqob0bzPrD0ezBJ/y3rpaXe+XR4tXyAtT1i899imflrMNscfNWPdth27KrYhqLuMfenVP/xuiOQ8s/Ha0FVtCfNfjC839WU/Fy0ZbszD6HU2JpQzP6+0HSU0NXx4Bd3yYz9txYB6ekqtERn1dNx99+HvZjH/FslRImgPRvswrAoe3kX/RDwo2odL7XdfNBTvfN+GspuagOPHjzJXGYnXVnXEQ2PxnFfqM0Zz4+hJRhpRic/GEx5oj8NJ4wFl/530fLhrcJg52dMFFCJpciB1IvlFufF0/YyEckKYsN6zMb4IN4Anj72uv8n8jh6SbmrHt1qPVfgjfBAjfUpAyl38zU26r9E98nWovtH5V+iGmicMNNaMLGG13wP1e0uyhM/JF8keWcLS38T2wISDjieUnU/Y/RpSJpTNX1pYHR9pIsqEzwho0CUMZsEzzL7JEgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3/ATIJNhm+rhgCAAAAAElFTkSuQmCC' style={{width:'55px'}}/> 
        </Link>
         <p>Profile</p>
         <Link to='/chat'>
        <img src='data:image/png;base64,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'style={{width:'50px'}}/>
          </Link>
          <p>Home</p>
          <Link to='/login'>
          <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROc0HTFqVGn8K5lJiJx3l1cLx4voz3nxeN3w&s'style={{width:'35px'}}/>
           </Link>
            <p>Logout</p>
            </>
       </div>

    <div className='chat' >
  <h3>Home</h3>
 {Post.map(posts=>(
   <div key={posts.id}
   onMouseUp={handleMouseUp}  onMouseLeave={handleMouseLeave} onMouseDown={()=>handleMouseDown(posts.id)} 
   onTouchStart={()=>handleMouseDown(posts.id)} onTouchEnd={handleMouseUp}
   style={{display:'flex',gap:'15px',padding:'10px',border:'2px solid lightgrey',margin:'8px',width:'1120px'}}>
   <img src={posts.profileImg}alt='profile img'className='m-x'style={{width:'60px',height:'60px',objectFit:'cover',borderRadius:'80px'}}/>
   <div style={{display:'flex',flexDirection:'column'}}>
   <div>{posts.retweetFrom!==null && (
   <span style={{color:'grey',fontSize:'14px'}} ><b> Retweeted from @{posts.retweetFrom}. </b></span>
)}
<br></br>
  <span ><b>{posts.username} .</b></span>
   <span style={{whiteSpace:'nowrap',paddingLeft:'7px'}}>{posts.date}</span>
   </div>
   <p style={{paddingTop:'10px'}}>{posts.text}</p>
   {posts.image &&(
   <img src={posts.image}alt='profile img'className='m-x'style={{width:'80%',padding:' 8px 0px'}}/>
   )}
         <div className='icons' style={{display:'flex',gap:8}}>
      <span className='action-item'>
    <FontAwesomeIcon icon={regularHeart} style={{color:hover==='like'?'red' : 'gray'}} onMouseEnter={()=>setHover('like')} onMouseLeave={()=>setHover(null)}onClick={()=>dispatch(like(posts.id))}/>
    <span >{posts.likes}</span>
   </span>

      <span className='action-item'>
<FontAwesomeIcon icon={faComment}style={{color:hover==='tweet'?'blue' : 'gray'}} onMouseEnter={()=>setHover('tweet')} onMouseLeave={()=>setHover(null)} onClick={()=>{dispatch(comment(posts.id));setBox(posts.id);setShowTweet(true);}}/>
   <span>{posts.comments}</span>
</span>
  
      <span className='action-item'>
 <FontAwesomeIcon icon={faRetweet}style={{color:hover==='Retweet'?'green' : 'gray'}} onMouseEnter={()=>setHover('Retweet')} onMouseLeave={()=>setHover(null)}
    onClick={()=>{dispatch(retweetPost(posts.id));
    setBox(posts.id);setShowReTweet(true)}}/>
    <span>{posts.retweets}</span>
    </span>
 
    {showTrash === posts.id && (
            < FontAwesomeIcon icon={faTrashCan} onClick={()=>onDelete(posts.id)} style={{color:'red',right:'50px',cursor:'pointer'}}/>
         )}
   </div>                           
</div>   
</div>                        
    ))}  
{ShowTweet && (
     <Tweet Post={box}closeModal={()=>setShowTweet(false)}/>
      )}

       {ShowReTweet && (
     <Retweet Post={box} closeModal={()=>setShowReTweet(false)}/>
      )}

</div>
</div>

);
};

export default Chat;

/*    <div className='dialog' style={{display:'flex',flexDirection:'column',padding:'7px'}}>
/>
,flexDirection:'row',columnGap:'50px'
      )} */
 